import { isValid, parseISO } from 'date-fns';

/**
 * 驗證是否為有效的 URL
 * @param url - 要驗證的 URL
 * @returns 是否為有效 URL
 * @example isUrl('https://example.com') // true
 * @example isUrl('invalid-url') // false
 */
export const isUrl = (url: string | URL) => {
  try {
    return Boolean(new URL(url));
  } catch {
    return false;
  }
};

/**
 * 驗證是否為有效的 URL 或空字串
 * @param url - 要驗證的 URL
 * @returns 是否為有效 URL 或空字串
 * @example isUrlOrEmpty('https://example.com') // true
 * @example isUrlOrEmpty('') // true
 * @example isUrlOrEmpty('invalid-url') // false
 */
export const isUrlOrEmpty = (url: string | URL) => isUrl(url) || url === '';

/**
 * 驗證是否為有限數字（排除 Infinity、NaN 等）
 * @param n - 要驗證的值
 * @returns 是否為有限數字
 * @example isFiniteNumber(123) // true
 * @example isFiniteNumber('123') // true
 * @example isFiniteNumber(Infinity) // false
 * @example isFiniteNumber('abc') // false
 */
export const isFiniteNumber = (n: any) => {
  const inputType = typeof n;
  if (inputType !== 'number' && inputType !== 'string') {
    return false;
  }

  if (n === '') {
    return false;
  }

  return Number.isFinite(Number(n));
};

/**
 * 驗證是否為有效的 ISO 日期字串
 * @param dateString - 要驗證的日期字串
 * @returns 是否為有效的 ISO 日期字串
 * @example isISOString('2021-07-06T09:48:09') // true
 * @example isISOString('2021/07/06') // false
 * @example isISOString('invalid-date') // false
 */
export const isISOString = (dateString: any) => {
  if (typeof dateString !== 'string' || !dateString) {
    return false;
  }
  try {
    return isValid(parseISO(dateString));
  } catch {
    return false;
  }
};
